var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenarios(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "scenarios_svg__ionicon",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336 64h32c26.51 0 48 21.49 48 48v320c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h32M168.5 197.5h175M168.5 347.5h175M168.5 272.5h175"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 64,
    x: 176,
    y: 32,
    rx: 26.13
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarios);
export default __webpack_public_path__ + "static/media/scenarios.9e8c096f5c4c2c5dbf0acedffae3d3ec.svg";
export { ForwardRef as ReactComponent };